import usePutDevConfig from './dev/put_config';
import useSpecifications from './dev/specifications';
import useDefaultParamsByPnames from './param/by_name/default';
import useActualParamsByPnames from './param/by_name/actual';
import useActualParamsByPids from './param/by_id/actual';
import useResume from './dev/resume';
import useWorklineMonitor from './workline/monitor';
import useWorklineCraft from './workline/craft';
import useModuleList from './module/list';
import useMonitorCraftList from './craft/monitor_craft_list';
import useOnlineCraftList from './craft/online_craft_list';
import useOnlineCraftPost from './craft/online_craft_post';
import useStdCraftList from './craft/std_craft_list';
import useStdCraftListOld from './craft/std_craft_oldList';
import useTemplateCraftList from './craft/template_craft_list';
import useTemplateCraftPost from './craft/template_craft_post';
import useTemplateCraftPut from './craft/template_craft_put';
import useTemplateCraftDelete from './craft/template_craft_delete';
import useStdCraftParams from './craft/std_craft_params';
import useStdCraftDelete from './craft/std_craft_delete';
import useStdCraftStatePut from './craft/std_craft_state_put';
import useMainDevices from './dev/main_devices';
import useEfficiencyAnalysis from './oee/efficiency_analysis';
import useOverView from './oee/overview';
import useUtilizationRate from './oee/utilization_rate_overview';
import useMaterials from './material/material_list';
import usePigments from './material/pigment_list';
import useCode from './user/code';
import useParamChange from './param_change/get';
import useProductList from './product/list';
import useCraftParams from './craft/craft_params';
import useLanguages from './languages/languages';
import useCustomerOrders from './production_manage/customer_orders';
import useCraftSpotAll from './spot/craft_spot_all';
import useCraftSpotOrg from './spot/craft_spot_org';
import useCraftSpotOrgPost from './spot/craft_spot_org_post';
import useCraftSpotOrgDelete from './spot/craft_spot_org_delete';
import useCraftSpotAnalysis from './spot/craft_spot_analysis';
import useDevList from './dev/dev_list';
import useGetDevConfig from './dev/get_config';
import useGetWorklineDevices from './dev/list';
import usePutMaintain from './dev/put_maintain';
import useImportConfig from './dev/import_config';
import usePutDevice from './dev/put';
import useImportDevices from './dev/import_devices';
import useImportFile from './file/post';
import useAccessControl from './access/access';
import useGetUserConfig from './user_config/get_userconfig';
import usePutUserConfig from './user_config/put_userconfig';
import useGetProductionPlans from './production_manage/production_plan_list';
import useGetCustomerList from './customer/list';
import usePutStdCraft from './craft/put_manage_craft';
import useTurning from './craft/turning';
import useSetLimit from './craft/set_manage_craft_limit';
import usePostCustomerOrder from './production_manage/post_customer_order';
import usePutCustomerOrder from './production_manage/put_customer_order';
import useDeleteCustomerOrder from './production_manage/delete_customer_order';
import useProductInspectionSettingGet from './quality_control/product_inspection_setting/get';
import useProductInspectionSettingPost from './quality_control/product_inspection_setting/post';
import useProductInspectionSettingDelete from './quality_control/product_inspection_setting/delete';
import useProductInspectionSettingPut from './quality_control/product_inspection_setting/put';
import useProductInspectionSettingDetailsPut from './quality_control/product_inspection_setting/details_put';
import useProductInspectionSettingDetailsGet from './quality_control/product_inspection_setting/details_get';
import useProductInspectionSettingDetailsPost from './quality_control/product_inspection_setting/details_post';
import useProductInspectionSettingDetailsDelete from './quality_control/product_inspection_setting/details_delete';
import useDefectCategoryGet from './quality_control/defect_category/get';
import useDefectCategoryPost from './quality_control/defect_category/post';
import useDefectCategoryDelete from './quality_control/defect_category/delete';
import useDefectCategoryPut from './quality_control/defect_category/put';
import useTestingMethodAllGet from './quality_control/testing_method/getAll';
import useTestingMethodGet from './quality_control/testing_method/get';
import useTestingMethodPost from './quality_control/testing_method/post';
import useTestingMethodDelete from './quality_control/testing_method/delete';
import useTestingMethodPut from './quality_control/testing_method/put';
import useTestItemsAllGet from './quality_control/test_items/getAll';
import useTestItemsGet from './quality_control/test_items/get';
import useTestItemsPost from './quality_control/test_items/post';
import useTestItemsDelete from './quality_control/test_items/delete';
import useTestItemsPut from './quality_control/test_items/put';
import useFactoryInformationPositionGet from './factory_location/factory_information/getPosition';
import useFactoryInformationGet from './factory_location/factory_information/get';
import useFactoryInformationPost from './factory_location/factory_information/post';
import useFactoryInformationDelete from './factory_location/factory_information/delete';
import useFactoryInformationPut from './factory_location/factory_information/put';
import useLocationInformationGet from './factory_location/location_information/get';
import useLocationInformationPost from './factory_location/location_information/post';
import useLocationInformationDelete from './factory_location/location_information/delete';
import useLocationInformationPut from './factory_location/location_information/put';
import useWorkshopInformationGet from './factory_location/workshop_information/get';
import useWorkshopInformationPost from './factory_location/workshop_information/post';
import useWorkshopInformationDelete from './factory_location/workshop_information/delete';
import useWorkshopInformationPut from './factory_location/workshop_information/put';
import useWorkshopPositionGet from './factory_location/workshop_position/get';
import usePostProductionPlan from './production_manage/production_plan_post';
import usePutProductionPlan from './production_manage/production_plan_put';
import useDeleteProductionPlan from './production_manage/production_plan_delete';
import useGetProductionOrders from './production_manage/production_order_list';
import usePostProductionOrder from './production_manage/production_order_post';
import usePostProductionOrderBatch from './production_manage/production_order_batch_post';
import usePutProductionOrderBatch from './production_manage/production_order_batch_put';
import usePutProductionOrder from './production_manage/production_order_put';
import useDeleteProductionOrder from './production_manage/production_order_delete';
import useGetCustomer from './customer/get';
import usePostCustomer from './customer/post';
import usePutCustomer from './customer/put';
import useGetProClassList from './produce_class/list';
import usePostProClass from './produce_class/post';
import usePutProClass from './produce_class/put';
import useDeleteProClass from './produce_class/delete';
import useCapacity from './capacity/capacity_analysis';
import useDeviceResume from './resume/device_resume';
import useMoldResume from './resume/mold_resume';
import useOrgList from './org/org_list';
import useOrgPost from './org/org_post';
import usePostModule from './module/post';
import usePutModule from './module/put';
import useGetMaterial from './material/material_get';
import usePostMaterial from './material/material_post';
import usePutMaterial from './material/material_put';
import usePostPigment from './material/pigment_post';
import usePutPigment from './material/pigment_put';
import useAdditives from './material/additive_list';
import usePostAdditive from './material/additive_post';
import usePutAdditive from './material/additive_put';
import usePostProduct from './product/post';
import usePutProduct from './product/put';
import useDeleteProduct from './product/delete';
import useDeleteMaterial from './material/material_delete';
import useDeletePigment from './material/pigment_delete';
import useDeleteAdditive from './material/additive_delete';
import useGetWorkerList from './worker/list';
import usePostWorker from './worker/post';
import usePutWorker from './worker/put';
import useDeleteWorker from './worker/delete';
import useGetHmiUsersPageList from './hmi_users/list_page';
import useGetHmiUsersList from './hmi_users/list';
import usePostHmiUsers from './hmi_users/post';
import usePutHmiUsers from './hmi_users/put';
import useDeleteHmiUsers from './hmi_users/delete';
import useFreeDevices from './work_lines/free_devices';
import usePutWorkline from './work_lines/put_worklines';
import usePostWorkline from './work_lines/post_worklines';
import useWorkLineList from './work_lines/workline_list';
import useGetCraft from './craft_param/get';
import useGetCraftList from './craft_param/list';
import usePostCraft from './craft_param/post';
import usePutCraft from './craft_param/put';
import useOrderCraftMonitor from './production_manage/order__monitor_main';
import useOrderCraftMonitorDetails from './production_manage/order__monitor_detail';
import useProductionPice from './production_manage/production_piece_main';
import useProductionPiceDetail from './production_manage/production_piece_detail';
import useDeleteCraft from './craft_param/delete';
import useAlarmAnalysisGet from './alarm_analysis/get';
import useStatusAnalysis from './status_analysis/status_analysis_list';
import useOnLineAnalysis from './status_analysis/online_analysis_list';
import useOperateAnalysis from './status_analysis/operate_analysis_list';
import useShutdownAnalysis from './status_analysis/shutdown_analysis_list';
import useProductCategoryGet from './product_category/get';
import useProductCategoryPost from './product_category/post';
import useProductCategoryDelete from './product_category/delete';
import useProductCategoryPut from './product_category/put';
import useMaterialCategoryGet from './material_category/get';
import useMaterialCategoryPageGet from './material_category/get_page';
import useMaterialCategoryPost from './material_category/post';
import useMaterialCategoryDelete from './material_category/delete';
import useMaterialCategoryPut from './material_category/put';
import useAllLanguages from './languages/all_languages';
import useShiftCapacity from './shift/get';
import useShiftCapacityDetail from './shift/detail_get';
import useOrgPut from './org/org_put';
import useOrgDelete from './org/org_delete';
import useOrderStatusList from './order_status_record/list';
import useAlarmMonitorList from './device_manage/device_alarm_monitor_list';
import useAlarmMonitorPut from './device_manage/device_alarm_monitor_put';
import useDevExtra from './dev/dev_extra_list';
import usePutDevExtra from './dev/dev_extra_put';
import useProcessList from './process/process_list';
import useProcessPost from './process/process_post';
import useProcessPut from './process/process_put';
import useProcessDelete from './process/process_delete';
import useRoleList from './role/role_list';
import useRolePost from './role/role_post';
import useRolePut from './role/role_put';
import useRoleDelete from './role/role_delete';
import useProcessActionList from './process_action/process_action_list';
import useProcessActionPost from './process_action/process_action_post';
import useProcessActionPut from './process_action/process_action_put';
import useProcessActionDelete from './process_action/process_action_delete';
import useReportStatus from './completion_report/status';
import useUserList from './users/user_list';
import useUserPost from './users/user_post';
import useUserPut from './users/user_put';
import useUserDelete from './users/user_delete';
import useUserRoleList from './user_role/user_role_list';
import useUserRolePost from './user_role/user_role_post';
import useUserRolePut from './user_role/user_role_put';
import useUserRoleDelete from './user_role/user_role_delete';
import useShutdownReason from './shutdown_reason/list';
import useShutdownReasonGet from './shutdown_reason/get';
import useShutdownReasonGetPage from './shutdown_reason/get_page';
import useShutdownReasonPost from './shutdown_reason/post';
import useShutdownReasonDelete from './shutdown_reason/delete';
import useShutdownReasonPut from './shutdown_reason/put';
import useShutdownReasonRecordGet from './shutdown_reason/record/get';
import useShutdownReasonRecordPost from './shutdown_reason/record/post';
import useShutdownReasonRecordDelete from './shutdown_reason/record/delete';
import useShutdownReasonRecordPut from './shutdown_reason/record/put';
import useShutdownReasonRecordMain from './shutdown_reason/record/getMain';
import useShutdownReasonRecordMainAll from './shutdown_reason/record/getMainAll';
import useShutdownReasonQueryMain from './shutdown_reason/query/queryMain';
import useShutdownReasonQueryDetail from './shutdown_reason/query/queryDetail';
import useLogin from './login/post';
import useProduceProcessAnalysis from './quality_control/produce_process_analysis/main';
import useQuality from './quality_control/produce_process_analysis/quality';
import useTemperature from './quality_control/produce_process_analysis/temperature';
import useProductionCycle from './quality_control/produce_process_analysis/cycle';
import useDeleteMould from './module/delete';
import useProcesses from './process/processes';
import useInferior from './quality_analysis/inferior';
import useInspectionItem from './quality_analysis/inspection_item';
import useMouldTestPass from './quality_analysis/mould_test_pass';
import useMouldTestPassDetail from './quality_analysis/mould_test_pass_detail';
import useSiteInspectionPass from './quality_analysis/site_inspection_pass';
import useSiteInspectionPassDetail from './quality_analysis/site_inspection_pass_detail';
import useSealing from './quality_analysis/sealing';
import useSealingDetail from './quality_analysis/sealing_detail';
import useWorkOrderDispatch from './production_manage/dispatch';
import useGetSns from './sns/get_sns';
import useRolesAuthorityList from './roles_authority/roles_authority_list';
import useRolesAuthorityPost from './roles_authority/roles_authority_post';
import useRolesAuthorityPostNew from './roles_authority/roles_authority_post_new';
import useUsersOrgsAuthorityList from './user_org_authority/user_org_authority_list';
import useUsersOrgsAuthorityPost from './user_org_authority/user_org_authority_post';
import useUsersOrgsAuthorityDelete from './user_org_authority/user_org_authority_delete';
import useProcessAuthority from './login/process_authority';
import useRefreshToken, { useTokenTime } from './login/refreshToken';
import useDispatchDelete from './production_manage/dispatch_delete';
import useGetProductionInferior from './production_manage/production_inferior_list';
import usePostProductionInferior from './production_manage/production_inferior_post';
import usePutProductionInferior from './production_manage/production_inferior_put';
import useDeleteProductionInferior from './production_manage/production_inferior_delete';
import useSealingInspectionMainPost from './sealing_inspection/main/post';
import useSealingInspectionMainPut from './sealing_inspection/main/put';
import useSealingInspectionMainDelete from './sealing_inspection/main/delete';
import useSealingInspectionMainGet from './sealing_inspection/main/get';
import useSealingInspectionUnqualifiedPost from './sealing_inspection/unqualified/post';
import useSealingInspectionUnqualifiedPut from './sealing_inspection/unqualified/put';
import useSealingInspectionUnqualifiedDelete from './sealing_inspection/unqualified/delete';
import useSealingInspectionUnqualifiedGet from './sealing_inspection/unqualified/get';
import useSealingInspectionValueList from './sealing_inspection/value/list';
import useSealingInspectionValuePost from './sealing_inspection/value/post';
import useSealingInspectionValuePut from './sealing_inspection/value/put';
import useSealingInspectionValueDelete from './sealing_inspection/value/delete';
import useSealingConfigGet from './sealing_inspection/configGet';
import useSealingSns from './sealing_inspection/sealingSn';
import useDeleteCustomer from './customer/delete';
import usePreviews from './dev/previews';
import useDeleteHMIOnlineCraft from './craft/hmi_online_craft_delete';
import useDeleteOnlineCraft from './craft/online_craft_delete';
import useFirstInspectionMain from './quality_control/first_inspection/main_get';
import useFirstInspectionMainPost from './quality_control/first_inspection/main_post';
import useFirstInspectionMainPut from './quality_control/first_inspection/main_put';
import useFirstInspectionMainDelete from './quality_control/first_inspection/main_delete';
import useProdInspectionItem from './quality_control/first_inspection/inspectionItems';
import useFirstInspectionSample from './quality_control/first_inspection/sample_get';
import useFirstInspectionSamplePost from './quality_control/first_inspection/sample_post';
import useFirstInspectionSamplePut from './quality_control/first_inspection/sample_put';
import useFirstInspectionSampleDelete from './quality_control/first_inspection/sample_delete';
import useFirstInspectionInferiors from './quality_control/first_inspection/inferiors_get';
import useFirstInspectionInferiorPost from './quality_control/first_inspection/inferiors_post';
import useFirstInspectionInferiorPut from './quality_control/first_inspection/inferiors_put';
import useFirstInspectionInferiorDelete from './quality_control/first_inspection/inferiors_delete';
import useSiteInspectionMain from './quality_control/site_inspection/main_get';
import useSiteInspectionMainPost from './quality_control/site_inspection/main_post';
import useSiteInspectionMainPut from './quality_control/site_inspection/main_put';
import useSiteInspectionMainDelete from './quality_control/site_inspection/main_delete';
import useProdSiteInspectionItem from './quality_control/site_inspection/inspectionItems';
import useSiteInspectionSample from './quality_control/site_inspection/sample_get';
import useSiteInspectionSamplePost from './quality_control/site_inspection/sample_post';
import useSiteInspectionSamplePut from './quality_control/site_inspection/sample_put';
import useSiteInspectionSampleDelete from './quality_control/site_inspection/sample_delete';
import useSiteInspectionInferiors from './quality_control/site_inspection/inferiors_get';
import useSiteInspectionInferiorPost from './quality_control/site_inspection/inferiors_post';
import useSiteInspectionInferiorPut from './quality_control/site_inspection/inferiors_put';
import useSiteInspectionInferiorDelete from './quality_control/site_inspection/inferiors_delete';
import useUserSecretKeyInfoGet from './user_secret_key_info/get';
import useUserSecretKeyInfoPost from './user_secret_key_info/post';
import useUserSecretKeyInfoDelete from './user_secret_key_info/delete';
import useUserSecretKeyInfoPut from './user_secret_key_info/put';
import useCreateQRCodePost from './create_qr_code/post';
import useProductHistory from './product_history/product_history';
import useImport from './file/import';
import useMachieFault from './device_maintain/machine_fault/list';
import useMachieFaultGet from './device_maintain/machine_fault/get';
import useMachieFaultPost from './device_maintain/machine_fault/post';
import useMachieFaultDelete from './device_maintain/machine_fault/delete';
import useMachieFaultPut from './device_maintain/machine_fault/put';
import useMaintainItem from './device_maintain/maintain_item/list';
import useMaintainItemGet from './device_maintain/maintain_item/get';
import useMaintainItemPost from './device_maintain/maintain_item/post';
import useMaintainItemDelete from './device_maintain/maintain_item/delete';
import useMaintainItemPut from './device_maintain/maintain_item/put';
import useMaintainGroup from './device_maintain/maintain_group/list';
import useMaintainGroupGet from './device_maintain/maintain_group/get';
import useMaintainGroupPost from './device_maintain/maintain_group/post';
import useMaintainGroupDelete from './device_maintain/maintain_group/delete';
import useMaintainGroupPut from './device_maintain/maintain_group/put';
import useMaintainGroupDetail from './device_maintain/maintain_group/detail/list';
import useMaintainGroupDetailGet from './device_maintain/maintain_group/detail/get';
import useMaintainGroupDetailPost from './device_maintain/maintain_group/detail/post';
import useMaintainGroupDetailDelete from './device_maintain/maintain_group/detail/delete';
import useMaintainGroupDetailPut from './device_maintain/maintain_group/detail/put';
import usePublishDevs from './dev/publish_devs';
import useDevPNSN from './dev/dev_extra_pn_sn';
import useVersion from './version/version';
import useWorkerDispatch from './worker/worker_dispatch';
import useMaintainPlan from './device_maintain/maintain_plan/list';
import useMaintainPlanGet from './device_maintain/maintain_plan/get';
import useMaintainPlanPost from './device_maintain/maintain_plan/post';
import useMaintainPlanDelete from './device_maintain/maintain_plan/delete';
import useMaintainPlanPut from './device_maintain/maintain_plan/put';
import useSpare from './spare/list';
import useSpareGet from './spare/get';
import useSparePost from './spare/post';
import useSpareDelete from './spare/delete';
import useSparePut from './spare/put';
import useMaintainRecord from './device_maintain/maintain_record/list';
import useMaintainRecordGet from './device_maintain/maintain_record/get';
import useMaintainRecordPost from './device_maintain/maintain_record/post';
import useMaintainRecordDelete from './device_maintain/maintain_record/delete';
import useMaintainRecordPut from './device_maintain/maintain_record/put';
import useMoldUnqualified from './mold_maintain/mold_unqualified/list';
import useMoldUnqualifiedGet from './mold_maintain/mold_unqualified/get';
import useMoldUnqualifiedPost from './mold_maintain/mold_unqualified/post';
import useMoldUnqualifiedDelete from './mold_maintain/mold_unqualified/delete';
import useMoldUnqualifiedPut from './mold_maintain/mold_unqualified/put';
import useMoldSpotcheck from './mold_maintain/mold_spotcheck/list';
import useMoldSpotcheckGet from './mold_maintain/mold_spotcheck/get';
import useMoldSpotcheckPost from './mold_maintain/mold_spotcheck/post';
import useMoldSpotcheckDelete from './mold_maintain/mold_spotcheck/delete';
import useMoldSpotcheckPut from './mold_maintain/mold_spotcheck/put';
import useMaintainRecoverMach from './device_maintain/maintain_recover/list';
import useMaintainRecoverMachGet from './device_maintain/maintain_recover/get';
import useMaintainRecoverMachPost from './device_maintain/maintain_recover/post';
import useMaintainRecoverMachDelete from './device_maintain/maintain_recover/delete';
import useMaintainRecoverMachPut from './device_maintain/maintain_recover/put';
import MFTM from './device_maintain/mach_static/faultTypeMain';
import MFTD from './device_maintain/mach_static/faultTypeDetail';
import useMaintainRecordDetail from './device_maintain/maintain_record/detail/list';
import useMaintainRecordDetailGet from './device_maintain/maintain_record/detail/get';
import useMaintainRecordDetailPut from './device_maintain/maintain_record/detail/put';
import useMaintainRecoverMold from './mold_maintain/maintain_recover/list';
import useMaintainRecoverMoldGet from './mold_maintain/maintain_recover/get';
import useMaintainRecoverMoldPost from './mold_maintain/maintain_recover/post';
import useMaintainRecoverMoldDelete from './mold_maintain/maintain_recover/delete';
import useMaintainRecoverMoldPut from './mold_maintain/maintain_recover/put';
import useAllDevices from './dev/dev_all';
import useDeleteWorkLine from './work_lines/delete_worklines';
import useTempData from './quality_control/produce_process_analysis/temp_data';
import useCraftManagePost from './craft/craft_manage_add';
import useAddToManageCraft520 from './craft/add_to_manage_520';
import useQualityData from './quality_control/produce_process_analysis/quality_data';
import useUpdateParamStatistic from './craft/update_param_statistic';
import mouldUseStatisticsGet from './mold_production_indicator_anaysis/get';
import useHiveManageGet from './hive_manage/get';
import useProductUseStatisticsGet from './product/get_statistic';
import useCraftUseStatisticsGet from './craft/get_statistic';
import useLogoutTime from './login/logout_time';
import useDeviceOeeAnalysis from './oee/device_oee_analysis';
import useDeviceOeeAnalysisDetail from './oee/device_oee_analysis_detail';
import useDeviceOeeList from './oee/device_oee_list';
import useIPQCProcessInspectionList from './ipqc_process_inspection/get';
import useIPQCProcessInspectionListAll from './ipqc_process_inspection/getAll';
import useIPQCProcessInspectionDelete from './ipqc_process_inspection/delete';
import useIPQCProcessInspectionPost from './ipqc_process_inspection/post';
import useIPQCProcessInspectionPut from './ipqc_process_inspection/put';
import useIPQCProcessInspectionSn from './ipqc_process_inspection/sn';
import useIPQTestItems from './ipqc_process_inspection/configGet';
import useFirstInspectionInferiorsPost from './ipqc_process_inspection/first_inspection/inferiors/post';
import useFirstInspectionInferiorsPut from './ipqc_process_inspection/first_inspection/inferiors/put';
import useFirstInspectionInferiorsDelete from './ipqc_process_inspection/first_inspection/inferiors/delete';
import useFirstInspectionInferiorsGet from './ipqc_process_inspection/first_inspection/inferiors/get';
import useFirstInspectionTestItemPost from './ipqc_process_inspection/first_inspection/test_item/post';
import useFirstInspectionTestItemPut from './ipqc_process_inspection/first_inspection/test_item/put';
import useFirstInspectionTestItemDelete from './ipqc_process_inspection/first_inspection/test_item/delete';
import useFirstInspectionTestItemGet from './ipqc_process_inspection/first_inspection/test_item/get';
import useInspectionInferiorsPost from './ipqc_process_inspection/inspection/inferiors/post';
import useInspectionInferiorsPut from './ipqc_process_inspection/inspection/inferiors/put';
import useInspectionInferiorsDelete from './ipqc_process_inspection/inspection/inferiors/delete';
import useInspectionInferiorsGet from './ipqc_process_inspection/inspection/inferiors/get';
import useInspectionTestItemPost from './ipqc_process_inspection/inspection/test_item/post';
import useInspectionTestItemPut from './ipqc_process_inspection/inspection/test_item/put';
import useInspectionTestItemDelete from './ipqc_process_inspection/inspection/test_item/delete';
import useInspectionTestItemGet from './ipqc_process_inspection/inspection/test_item/get';
import useSealingInspectionInferiorsPost from './ipqc_process_inspection/sealing_inspection/inferiors/post';
import useSealingInspectionInferiorsPut from './ipqc_process_inspection/sealing_inspection/inferiors/put';
import useSealingInspectionInferiorsDelete from './ipqc_process_inspection/sealing_inspection/inferiors/delete';
import useSealingInspectionInferiorsGet from './ipqc_process_inspection/sealing_inspection/inferiors/get';
import useSealingInspectionTestItemPost from './ipqc_process_inspection/sealing_inspection/test_item/post';
import useSealingInspectionTestItemPut from './ipqc_process_inspection/sealing_inspection/test_item/put';
import useSealingInspectionTestItemDelete from './ipqc_process_inspection/sealing_inspection/test_item/delete';
import useSealingInspectionTestItemGet from './ipqc_process_inspection/sealing_inspection/test_item/get';
import useProductionOrderGet from './production_manage/production_order_get';
import useProductionOrderGetCopy from './production_manage/production_order_get_copy';
import useIpqcReport from './quality_control/ipqc_report/get';
import useOEEMonitorGet from './oee/device_oee_monitor';
import useOEEMonitorPageGet from './oee/device_oee_monitor_page';
import useOEEMonitorPageCopyGet from './oee/device_oee_monitor_page_copy';
import useProductFormingMain from './product_forming_analysis/mian';
import useBasicDataList from './basic_data_setup/list';
import useEnergyBasicList from './energe_manage/energebasic/energebasic_list';
import usePutEnergyBasic from './energe_manage/energebasic/energebasic_put';
import usePostEnergyBasic from './energe_manage/energebasic/energebasic_post';
import useDeleteEnergyBasic from './energe_manage/energebasic/energebasic_delete';
import useEnergeTemplateList from './energe_manage/energetemplate/energetemplate_list';
import usePutEnergeTemplate from './energe_manage/energetemplate/energetemplate_put';
import usePostEnergeTemplate from './energe_manage/energetemplate/energetemplate_post';
import useDeleteEnergeTemplate from './energe_manage/energetemplate/energetemplate_delete';
import useProductFormingQuality from './product_forming_analysis/quality_data';
import useMaterialTypesList from './energe_manage/materialtypes/materialtypes_list';
import useProductAnalysis from './energe_manage/productanalysis/productanalysis_list';
import useCraftManageCopy from './craft/craft_manage_copy';
import useParamUpdate from './craft/craft_manage_update';
import useCraftParamsForManage from './craft/craft_param_for_mana';
import useEnergyDetails from './energe_manage/energydetails/energydetails';
import useEnergyStatus from './energe_manage/energydetails/energystatus';
import useProductionOverview from './production_overview/production_overview';
import useShiftCapacityNew from './shift/get_new';
import useEnergeDevice from './energe_manage/energydevice/energydevice';
import useMachMaintainReport from './device_maintain/maintain_report/list';
import useMoldMaintainReport from './mold_maintain/maintain_report/list';
import useStdCraftCompare from './craft/std_craft_compare';
import useProductCraftList from './craft/product_in_craft';
import useEnergyReport from './energe_manage/energystatistical/index';
import useEnergyFactoryArea from './energe_manage/energyoverview/factory';
import useMachineNums from './energe_manage/energyoverview/machineNums';
import useMachineNums2 from './energe_manage/energyoverview/machineNums2';
import useMachMaintainPlanView from './device_maintain/maintain_plan/machview';
import useMoldMaintainPlanView from './mold_maintain/maintain_plan/moldview';
import useOrderManageGet from './order_manage/get';
import useMaintainRecoverMoldDetailPost from './mold_maintain/maintain_recover/detail//post';
import useMaintainRecoverMoldDetailDelete from './mold_maintain/maintain_recover/detail/delete';
import useMaintainRecoverMoldDetailPut from './mold_maintain/maintain_recover/detail/put';
import useActualParams from './param/by_id/actual_param';
import useOverviews from './dev/overviews';
import useMachinesProduceBoard from './dev/machines_produce_board';
import useMachines from './dev/machines';
import useMachinesPost from './machines/post';
import useMachinesPut from './machines/put';
import useMachinesOnePage from './dev/machines_one_page';
import useModuleOnePage from './module/list_one_page';
import useModulePageList from './module/list_page';
import useAdditivePageList from './material/additive_list_page';
import useMaterialPageList from './material/material_list_page';
import usePigmentPageList from './material/pigment_list_page';
import useWorkLines from './work_lines/work_lines';
import useWorkLinePut from './work_lines/work_line_put';
import useProductionOrdersList from './production_manage/production_order_get';
import useProductionOverviews from './production_overview/production_overviews';
import useProductPageList from './product/product_page_list';
import useDeviceEfficiencyGet from './device_board/efficiency_get';
import useDeviceUtilizationTrendGet from './device_board/utilization_trend_get';
import useDeviceUtilizationTrend30Get from './device_board/utilization_trend30_get';
import useDeviceShutdownStatisticsGet from './device_board/shutdown_statistics_get';
import useDeviceAnalysisListGet from './device_board/analysis_list_get';
import useOrderCount7Get from './production_board/order_count7_get';
import useOrderCount30Get from './production_board/order_count30_get';
import useOrderMonthCountGet from './production_board/order_count12_get';
import useProductDefectGet from './production_board/product_defect_get';
import useOrderCountListGet from './production_board/order_list_get';
import useWorkOrderOverviews from './production_overview/workorder_overview';
import useGetProductionProgress from './production_progress/production_progress_get';
import useGetProductionProgressStatistical from './production_progress/production_progress_statistical';
import useBlockedDepartmentList from './production_progress/blocked_department_list';
import useBlockedReasonList from './production_progress/blocked_reason_list';
import usePostBlockedReason from './production_progress/production_plan_reason_post';
import useCapacityAnalysisDesGet from './device_capacity_board/capacity_analysis_des_get';
import useCapacityAnalysisListGet from './device_capacity_board/capacity_analysis_list_get';
import useShutdownAnalysisGet from './device_capacity_board/shutdown_analysis_get';
import useYieldPut from './yield_saved/put';
import useBlockedDepartmentPost from './production_progress/blocked_department_post';
import useBlockedDepartmentPut from './production_progress/blocked_department_put';
import useBlockedDepartmentDelete from './production_progress/blocked_department_delete';
import useBlockedReasonPost from './production_progress/blocked_reason_post';
import useBlockedReasonPut from './production_progress/blocked_reason_put';
import useBlockedReasonDelete from './production_progress/blocked_reason_delete';
import useDeviceStateStatisticsGet from './device_state_statistics/device_state_analysis_list';
import useDeviceStateDayClassGet from './device_state_statistics/device_state_day_class';
import useGetCraftMode from './craft/get_craft_mode';
import useMonitor from './monitor/monitor';
import useParamUpdateStatisticMain from './param_update_statistics/param_update_statistics_main';
import useParamUpdateStatisticDetail from './param_update_statistics/param_update_statistics_detail';
import useQualityInfoGet from './quality_board/quality_info_get';
import useQualityInfoListGet from './quality_board/quality_info_list_get';
import useInferiorDefectReasonGet from './quality_board/inferior_defect_reason_get';
import useInferiorInspectionReasonGet from './quality_board/inferior_inspection_reason_get';
import useCapacityMonitorGet from './device_capacity_monitor_board/capacity_monitor_list_get';
import useShutdownMonitorGet from './device_shutdown_monitor_board/shutdown_monitor_list_get';
import useReleaseLogGet from './release_log/get';
import useProductClassSelectStartGet from './produce_class/get_select_start';
import useProductClassSelectEndGet from './produce_class/get_select_end';
import useSystemSettingsGet from './system_settings/get';
import useSystemSettingsPut from './system_settings/put';
import useMaterialGroupPageList from './material/material_group_page';
import useParamsActual from './param/by_id/params_actual';
import useMachineModelGet from './device_model/get_page';
import useMachineModelPost from './device_model/post';
import useMachineModelDelete from './device_model/delete';
import useMachineModelPut from './device_model/put';
import useDeviceStatusStoptime from './transsky_device_capacity_monitor/device_status_stop_time_get';
import useDeviceCapacity3h from './transsky_device_capacity_monitor/device_capacity3h_get';
import useDeviceOrderInfo from './transsky_device_capacity_monitor/device_order_info_get';
import useMachStatus from './monitor/mach_status';
import useParamChanged from './monitor/param_changed';
import useAlarmsMonitor from './monitor/alarms';
import useExtraCraft from './craft/produce_craft_extra';
import useMaterialRecordsDelete from './material_records/delete';
import useMaterialRecordsGet from './material_records/get';
import useProduceOnlineCrafts from './craft/produce_online_craft';
import useDevExtraHiveSn from './dev/dev_extra_hivesn';
import useDevExtraHiveSnByLine from './dev/dev_hivesn_by_line';
import useOnlineCraftPut from './craft/online_craft_put';
import useProductHistoryList from './product_history/product_history_list';
import useNewProductHistoryList from './product_history/new_product_history_list';
import useNewProductHistoryExportList from './product_history/new_product_history_list_export';
import usePerShotcountCraft from './craft/per_shotcount_craft';
import useChildProductList from './product/child_product_list';
import useChildProductPost from './product/child_product_post';
import useChildProductPut from './product/child_product_put';
import useChildProductDelete from './product/child_product_delete';
import useGetSimpleProducts from './product/list_simple';
import useGetDeviceData from './production_units_table/production_units';
import useProductionMoldList from './product_mold_relation/production_mold_get';
import useProductionMoldPost from './product_mold_relation/production_mold_post';
import useProductionMoldDelete from './product_mold_relation/production_mold_delete';
import useProductUnquaStatistics from './product/unqua_statistics';
if (process.env.REACT_APP_DATA_ORIGIN === 'mock') {
  require('@/mock');
}

export {
  usePutDevConfig,
  useSpecifications,
  useDefaultParamsByPnames,
  useActualParamsByPnames,
  useActualParamsByPids,
  useResume,
  useWorklineMonitor,
  useWorklineCraft,
  useModuleList,
  useOverView,
  useTemplateCraftDelete,
  useUtilizationRate,
  useMonitorCraftList,
  useOnlineCraftList,
  useOnlineCraftPost,
  useTemplateCraftList,
  useTemplateCraftPost,
  useTemplateCraftPut,
  useStdCraftParams,
  useStdCraftList,
  useStdCraftListOld,
  useStdCraftDelete,
  useStdCraftStatePut,
  useMaterials,
  usePigments,
  useMainDevices,
  useEfficiencyAnalysis,
  useCode,
  useParamChange,
  useProductList,
  useCraftParams,
  useLanguages,
  useGetProductionOrders,
  useCustomerOrders,
  useAdditives,
  useCraftSpotAll,
  useCraftSpotOrg,
  useCraftSpotOrgPost,
  useCraftSpotOrgDelete,
  useCraftSpotAnalysis,
  useDevList,
  useGetDevConfig,
  useGetWorklineDevices,
  usePutMaintain,
  useImportConfig,
  usePutDevice,
  useImportDevices,
  useAccessControl,
  useGetUserConfig,
  usePutUserConfig,
  useGetProductionPlans,
  useGetCustomerList,
  usePutStdCraft,
  useTurning,
  useSetLimit,
  usePostCustomerOrder,
  usePutCustomerOrder,
  useDeleteCustomerOrder,
  useProductInspectionSettingGet,
  useProductInspectionSettingPost,
  useProductInspectionSettingDelete,
  useProductInspectionSettingPut,
  useProductInspectionSettingDetailsPut,
  useProductInspectionSettingDetailsGet,
  useProductInspectionSettingDetailsPost,
  useProductInspectionSettingDetailsDelete,
  useImportFile,
  useDefectCategoryGet,
  useDefectCategoryPost,
  useDefectCategoryDelete,
  useDefectCategoryPut,
  useTestingMethodGet,
  useTestingMethodPost,
  useTestingMethodDelete,
  useTestingMethodPut,
  useTestItemsGet,
  useTestItemsPost,
  useTestItemsDelete,
  useTestItemsPut,
  useFactoryInformationPositionGet,
  useFactoryInformationGet,
  useFactoryInformationPost,
  useFactoryInformationDelete,
  useFactoryInformationPut,
  useLocationInformationGet,
  useLocationInformationPost,
  useLocationInformationDelete,
  useProductionPice,
  useProductionPiceDetail,
  useLocationInformationPut,
  useWorkshopInformationGet,
  useWorkshopInformationPost,
  useOrderCraftMonitor,
  useOrderCraftMonitorDetails,
  useWorkshopInformationDelete,
  useWorkshopInformationPut,
  useWorkshopPositionGet,
  usePostProductionPlan,
  usePutProductionPlan,
  useStatusAnalysis,
  useOnLineAnalysis,
  useOperateAnalysis,
  useShutdownAnalysis,
  useDeleteProductionPlan,
  usePostProductionOrder,
  usePostProductionOrderBatch,
  usePutProductionOrderBatch,
  usePutProductionOrder,
  useDeleteProductionOrder,
  useGetCustomer,
  usePostCustomer,
  usePutCustomer,
  useGetProClassList,
  usePostProClass,
  usePutProClass,
  useDeleteProClass,
  useCapacity,
  useDeviceResume,
  useMoldResume,
  useOrgList,
  useOrgPost,
  usePostModule,
  usePutModule,
  useGetMaterial,
  usePostMaterial,
  usePutMaterial,
  usePostPigment,
  usePutPigment,
  useAlarmMonitorList,
  useAlarmMonitorPut,
  usePostAdditive,
  usePutAdditive,
  usePostProduct,
  usePutProduct,
  useDeleteProduct,
  useDeleteMaterial,
  useDeletePigment,
  useDeleteAdditive,
  useGetWorkerList,
  usePostWorker,
  usePutWorker,
  useDeleteWorker,
  useGetHmiUsersPageList,
  useGetHmiUsersList,
  usePostHmiUsers,
  usePutHmiUsers,
  useDeleteHmiUsers,
  useFreeDevices,
  usePutWorkline,
  usePostWorkline,
  useWorkLineList,
  useGetCraft,
  useGetCraftList,
  usePostCraft,
  usePutCraft,
  useDeleteCraft,
  useAlarmAnalysisGet,
  useProductCategoryGet,
  useProductCategoryPost,
  useProductCategoryDelete,
  useProductCategoryPut,
  useAllLanguages,
  useShiftCapacity,
  useShiftCapacityDetail,
  useOrgPut,
  useOrgDelete,
  useOrderStatusList,
  useDevExtra,
  usePutDevExtra,
  useProcessList,
  useProcessPost,
  useProcessPut,
  useProcessDelete,
  useRoleList,
  useRolePost,
  useRolePut,
  useRoleDelete,
  useProcessActionList,
  useProcessActionPost,
  useProcessActionPut,
  useProcessActionDelete,
  useReportStatus,
  useUserList,
  useUserPost,
  useUserPut,
  useUserDelete,
  useUserRoleList,
  useUserRolePost,
  useUserRolePut,
  useUserRoleDelete,
  useShutdownReason,
  useShutdownReasonGet,
  useShutdownReasonGetPage,
  useShutdownReasonPost,
  useShutdownReasonDelete,
  useShutdownReasonPut,
  useShutdownReasonRecordGet,
  useShutdownReasonRecordPost,
  useShutdownReasonRecordDelete,
  useShutdownReasonRecordPut,
  useShutdownReasonRecordMain,
  useShutdownReasonRecordMainAll,
  useShutdownReasonQueryMain,
  useShutdownReasonQueryDetail,
  useLogin,
  useProduceProcessAnalysis,
  useQuality,
  useTemperature,
  useProductionCycle,
  useDeleteMould,
  useProcesses,
  useInferior,
  useInspectionItem,
  useMouldTestPass,
  useMouldTestPassDetail,
  useSiteInspectionPass,
  useSiteInspectionPassDetail,
  useSealing,
  useSealingDetail,
  useWorkOrderDispatch,
  useGetSns,
  useRolesAuthorityList,
  useRolesAuthorityPost,
  useRolesAuthorityPostNew,
  useUsersOrgsAuthorityList,
  useUsersOrgsAuthorityPost,
  useUsersOrgsAuthorityDelete,
  useDispatchDelete,
  useProcessAuthority,
  useRefreshToken,
  useTokenTime,
  useGetProductionInferior,
  usePostProductionInferior,
  usePutProductionInferior,
  useDeleteProductionInferior,
  useSealingInspectionMainPost,
  useSealingInspectionMainPut,
  useSealingInspectionMainDelete,
  useSealingInspectionMainGet,
  useSealingInspectionUnqualifiedPost,
  useSealingInspectionUnqualifiedPut,
  useSealingInspectionUnqualifiedDelete,
  useSealingInspectionUnqualifiedGet,
  useSealingInspectionValueList,
  useSealingInspectionValuePost,
  useSealingInspectionValuePut,
  useSealingInspectionValueDelete,
  useSealingConfigGet,
  useSealingSns,
  useDeleteCustomer,
  usePreviews,
  useDeleteHMIOnlineCraft,
  useDeleteOnlineCraft,
  useFirstInspectionMain,
  useFirstInspectionMainPost,
  useFirstInspectionMainPut,
  useFirstInspectionMainDelete,
  useFirstInspectionSample,
  useFirstInspectionSamplePost,
  useFirstInspectionSamplePut,
  useFirstInspectionSampleDelete,
  useFirstInspectionInferiors,
  useFirstInspectionInferiorPost,
  useFirstInspectionInferiorPut,
  useFirstInspectionInferiorDelete,
  useProdInspectionItem,
  useSiteInspectionMain,
  useSiteInspectionMainPost,
  useSiteInspectionMainPut,
  useSiteInspectionMainDelete,
  useSiteInspectionSample,
  useSiteInspectionSamplePost,
  useSiteInspectionSamplePut,
  useSiteInspectionSampleDelete,
  useSiteInspectionInferiors,
  useSiteInspectionInferiorPost,
  useSiteInspectionInferiorPut,
  useSiteInspectionInferiorDelete,
  useProdSiteInspectionItem,
  useUserSecretKeyInfoGet,
  useUserSecretKeyInfoPost,
  useUserSecretKeyInfoDelete,
  useUserSecretKeyInfoPut,
  useCreateQRCodePost,
  useProductHistory,
  useImport,
  useMachieFault,
  useMachieFaultGet,
  useMachieFaultPost,
  useMachieFaultDelete,
  useMachieFaultPut,
  useMaintainItem,
  useMaintainItemGet,
  useMaintainItemPost,
  useMaintainItemDelete,
  useMaintainItemPut,
  useMaintainGroup,
  useMaintainGroupGet,
  useMaintainGroupPost,
  useMaintainGroupDelete,
  useMaintainGroupPut,
  useMaintainGroupDetail,
  useMaintainGroupDetailGet,
  useMaintainGroupDetailPost,
  useMaintainGroupDetailDelete,
  useMaintainGroupDetailPut,
  usePublishDevs,
  useDevPNSN,
  useVersion,
  useWorkerDispatch,
  useMaintainPlan,
  useMaintainPlanGet,
  useMaintainPlanPost,
  useMaintainPlanDelete,
  useMaintainPlanPut,
  useSpare,
  useSpareGet,
  useSparePost,
  useSpareDelete,
  useSparePut,
  useMaintainRecord,
  useMaintainRecordGet,
  useMaintainRecordPost,
  useMaintainRecordDelete,
  useMaintainRecordPut,
  useMoldUnqualified,
  useMoldUnqualifiedGet,
  useMoldUnqualifiedPost,
  useMoldUnqualifiedDelete,
  useMoldUnqualifiedPut,
  useMoldSpotcheck,
  useMoldSpotcheckGet,
  useMoldSpotcheckPost,
  useMoldSpotcheckDelete,
  useMoldSpotcheckPut,
  useMaintainRecoverMach,
  useMaintainRecoverMachGet,
  useMaintainRecoverMachPost,
  useMaintainRecoverMachDelete,
  useMaintainRecoverMachPut,
  MFTD,
  MFTM,
  useMaintainRecordDetail,
  useMaintainRecordDetailGet,
  useMaintainRecordDetailPut,
  useMaintainRecoverMold,
  useMaintainRecoverMoldGet,
  useMaintainRecoverMoldPost,
  useMaintainRecoverMoldDelete,
  useMaintainRecoverMoldPut,
  useAllDevices,
  useDeleteWorkLine,
  useTempData,
  useCraftManagePost,
  useAddToManageCraft520,
  useQualityData,
  useUpdateParamStatistic,
  mouldUseStatisticsGet,
  useHiveManageGet,
  useProductUseStatisticsGet,
  useCraftUseStatisticsGet,
  useLogoutTime,
  useDeviceOeeAnalysis,
  useDeviceOeeAnalysisDetail,
  useDeviceOeeList,
  useIPQCProcessInspectionList,
  useIPQCProcessInspectionListAll,
  useIPQCProcessInspectionDelete,
  useIPQCProcessInspectionPost,
  useIPQCProcessInspectionPut,
  useIPQCProcessInspectionSn,
  useIPQTestItems,
  useFirstInspectionInferiorsPost,
  useFirstInspectionInferiorsPut,
  useFirstInspectionInferiorsDelete,
  useFirstInspectionInferiorsGet,
  useFirstInspectionTestItemPost,
  useFirstInspectionTestItemPut,
  useFirstInspectionTestItemDelete,
  useFirstInspectionTestItemGet,
  useInspectionInferiorsPost,
  useInspectionInferiorsPut,
  useInspectionInferiorsDelete,
  useInspectionInferiorsGet,
  useInspectionTestItemPost,
  useInspectionTestItemPut,
  useInspectionTestItemDelete,
  useInspectionTestItemGet,
  useSealingInspectionInferiorsPost,
  useSealingInspectionInferiorsPut,
  useSealingInspectionInferiorsDelete,
  useSealingInspectionInferiorsGet,
  useSealingInspectionTestItemPost,
  useSealingInspectionTestItemPut,
  useSealingInspectionTestItemDelete,
  useSealingInspectionTestItemGet,
  useProductionOrderGet,
  useProductionOrderGetCopy,
  useIpqcReport,
  useOEEMonitorGet,
  useOEEMonitorPageGet,
  useOEEMonitorPageCopyGet,
  useProductFormingMain,
  useBasicDataList,
  useEnergyBasicList,
  usePutEnergyBasic,
  usePostEnergyBasic,
  useDeleteEnergyBasic,
  useEnergeTemplateList,
  usePutEnergeTemplate,
  usePostEnergeTemplate,
  useDeleteEnergeTemplate,
  useProductFormingQuality,
  useMaterialTypesList,
  useProductAnalysis,
  useCraftManageCopy,
  useParamUpdate,
  useCraftParamsForManage,
  useEnergyDetails,
  useEnergyStatus,
  useProductionOverview,
  useShiftCapacityNew,
  useMaterialCategoryGet,
  useMaterialCategoryPageGet,
  useMaterialCategoryPost,
  useMaterialCategoryDelete,
  useMaterialCategoryPut,
  useEnergeDevice,
  useMachMaintainReport,
  useMoldMaintainReport,
  useStdCraftCompare,
  useEnergyReport,
  useEnergyFactoryArea,
  useMachineNums,
  useMachineNums2,
  useProductCraftList,
  useMachMaintainPlanView,
  useMoldMaintainPlanView,
  useOrderManageGet,
  useMaintainRecoverMoldDetailPost,
  useMaintainRecoverMoldDetailDelete,
  useMaintainRecoverMoldDetailPut,
  useActualParams,
  useOverviews,
  useMachines,
  useMachinesPost,
  useMachinesPut,
  useMachinesOnePage,
  useModuleOnePage,
  useModulePageList,
  useAdditivePageList,
  useMaterialPageList,
  usePigmentPageList,
  useWorkLines,
  useWorkLinePut,
  useProductionOrdersList,
  useTestItemsAllGet,
  useTestingMethodAllGet,
  useProductionOverviews,
  useProductPageList,
  useDeviceEfficiencyGet,
  useDeviceUtilizationTrendGet,
  useDeviceUtilizationTrend30Get,
  useDeviceShutdownStatisticsGet,
  useDeviceAnalysisListGet,
  useOrderCount7Get,
  useOrderCount30Get,
  useOrderMonthCountGet,
  useProductDefectGet,
  useOrderCountListGet,
  useWorkOrderOverviews,
  useGetProductionProgress,
  useGetProductionProgressStatistical,
  useBlockedDepartmentList,
  useBlockedReasonList,
  usePostBlockedReason,
  useCapacityAnalysisDesGet,
  useCapacityAnalysisListGet,
  useShutdownAnalysisGet,
  useYieldPut,
  useBlockedDepartmentPost,
  useBlockedDepartmentPut,
  useBlockedDepartmentDelete,
  useBlockedReasonPost,
  useBlockedReasonPut,
  useBlockedReasonDelete,
  useGetCraftMode,
  useMonitor,
  useDeviceStateStatisticsGet,
  useDeviceStateDayClassGet,
  useParamUpdateStatisticMain,
  useParamUpdateStatisticDetail,
  useQualityInfoGet,
  useQualityInfoListGet,
  useInferiorDefectReasonGet,
  useInferiorInspectionReasonGet,
  useCapacityMonitorGet,
  useShutdownMonitorGet,
  useReleaseLogGet,
  useProductClassSelectStartGet,
  useProductClassSelectEndGet,
  useSystemSettingsGet,
  useSystemSettingsPut,
  useMaterialGroupPageList,
  useParamsActual,
  useMachineModelGet,
  useMachineModelPost,
  useMachineModelDelete,
  useMachineModelPut,
  useDeviceStatusStoptime,
  useDeviceCapacity3h,
  useDeviceOrderInfo,
  useMachStatus,
  useParamChanged,
  useAlarmsMonitor,
  useExtraCraft,
  useMaterialRecordsDelete,
  useMaterialRecordsGet,
  useProduceOnlineCrafts,
  useDevExtraHiveSn,
  useDevExtraHiveSnByLine,
  useOnlineCraftPut,
  useProductHistoryList,
  usePerShotcountCraft,
  useChildProductList,
  useChildProductPost,
  useChildProductPut,
  useChildProductDelete,
  useGetSimpleProducts,
  useNewProductHistoryList,
  useNewProductHistoryExportList,
  useGetDeviceData,
  useMachinesProduceBoard,
  useProductionMoldList,
  useProductionMoldPost,
  useProductionMoldDelete,
  useProductUnquaStatistics,
};
